import React, { useRef, useState } from "react"

export default function AudioPlayer({ file }) {
  const player = useRef()
  const [playing, setPlaying] = useState(false)

  const play = () => {
    player.current.play()
    setPlaying(true)
  }

  const pause = () => {
    player.current.pause()
    setPlaying(false)
  }

  const resetPlayer = () => {
    player.current.load()
    setPlaying(false)
  }

  return (
    <div className="member-voices__play">
      {playing ? (
        <button onClick={pause}>
          <span className="icon--pause"></span>Pause
        </button>
      ) : (
        <button onClick={play}>
          <span className="icon--play"></span>Listen
        </button>
      )}

      <audio src={file} ref={player} onEnded={resetPlayer}>
        Your browser does not support the
        <code>audio</code> element.
      </audio>
    </div>
  )
}
